import React from 'react';
import style from './KimGroup.module.scss';
import KimCustomersSuppliersInfo from '../../blocks/PageInfo/KimGroupIngo/KimCustomersSuppliersInfo';

const KimCustomersSuppliers: React.FC = () => (
  <>
    <div className={style.container}>
      <KimCustomersSuppliersInfo />
    </div>
    <div className={style.frame}>
      <iframe
        width="100%"
        height="100%"
        src="https://pix.tektorg.ru/shared/view/776ca40e-ed94-42dc-9ccf-bdd494aa615e"
        title="kim-customers-suppliers"
      />
    </div>
  </>
);

export default KimCustomersSuppliers;
